export default __webpack_public_path__ + "static/media/art-pro-blk-banner-1.a4c17648.jpg";